// Fallback column config — mirrors the "dataDownloadHistoryTable" page meta JSON exactly.
// When getPagesMetaData("dataDownload") succeeds, the backend config takes precedence.

export const TABLE_COLUMNS = {
  createdAt: {
    key: "createdAt",
    title: "Requested On Date",
    width: 170,
    sorter: true,
    dataIndex: "createdAt",
    dateFormat: "DD MMM'YY hh:mm A",
    defaultValue: "-",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    tooltipDateFormat: "relative",
    valueRenderingType: "timestamp",
  },
  dataDownloadType: {
    key: "dataDownloadType",
    title: "Download Category",
    width: 150,
    sorter: true,
    dataIndex: "dataDownloadType",
    defaultValue: "-",
    valueRenderingType: "text",
  },
  status: {
    key: "status",
    title: "Status",
    width: 150,
    sorter: true,
    dataIndex: "status",
    defaultValue: "-",
    valueRenderingType: "status_custom",
  },
  fromTime: {
    key: "fromTime",
    title: "Start Date Time",
    width: 170,
    sorter: true,
    dataIndex: "fromTime",
    dateFormat: "DD MMM'YY hh:mm A",
    defaultValue: "-",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    tooltipDateFormat: "relative",
    valueRenderingType: "timestamp",
  },
  toTime: {
    key: "toTime",
    title: "End Date Time",
    width: 170,
    sorter: true,
    dataIndex: "toTime",
    dateFormat: "DD MMM'YY hh:mm A",
    defaultValue: "-",
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    tooltipDateFormat: "relative",
    valueRenderingType: "timestamp",
  },
  downloadAction: {
    key: "downloadAction",
    title: "Download",
    width: 140,
    sorter: false,
    dataIndex: "downloadAction",
    defaultValue: "",
    valueRenderingType: "download_action",
  },
};

export const TABLE_COLUMN_ORDER = [
  "createdAt",
  "dataDownloadType",
  "status",
  "fromTime",
  "toTime",
  "downloadAction",
];

// Fallback filter config — mirrors "filterConfigurations.dataDownloadHistoryTable" exactly.
export const TABLE_FILTERS = [
  {
    key: "createdAt",
    type: "static",
    label: "Requested On Date",
    staticData: [],
    displayType: "dateCalender",
    queryParams: { table: "dataDownloads", column: "createdAt" },
  },
  {
    key: "status",
    type: "static",
    label: "Status",
    staticData: [
      { id: "OPEN",        value: "Open" },
      { id: "IN_PROGRESS", value: "In Progress" },
      { id: "SUCCESS",     value: "Success" },
      { id: "FAILED",      value: "Failed" },
    ],
    displayType: "multiSelectDropdown",
    queryParams: { table: "dataDownloads", column: "status" },
  },
];
